import {MakeDialog} from "../../../components/Shared/MakeDialog";
import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {getFormFieldValue} from "../../Applications/shared/shared";
import {postData} from "../../../api/doLogin";
import {getGlobalState} from "../../../constants/GlobalStore";
import {calendarCancelOptions, calendarRescheduleOptions} from "../constants/CalendarConstants";
import {getAARResultsByType, getAARStatus} from "../../../constants/AARConstants";

export class CancelCalendarDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: calendarCancelOptions[0].id,
      comment: "",
      loaded: true
    }
    this.loginId = getGlobalState("loginID");
  }

  saveToCalendar() {
    const self = this;
    const payload = {
      aarData: (this.props.apptType === 13 || this.props.apptType === 15) ? getAARStatus(200) : getAARStatus(0),
      reason: this.state.reason,
      comment: this.state.comment,
      action: "cancel"
    };
    payload['id'] = this.props.eventId;
    // console.log(payload);
    // return;
    postData(`calendar/cancel/${this.props.currentCalendar}`, payload, {})
      .then((data) => {
        if (data.status === "Success") {
          this.props.onSave && this.props.onSave(this.state.chosenCalendar);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {
    return (
      <MakeDialog isOpen={this.state.loaded}
                  className={"CancelCalendarDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            onClick={() => this.saveToCalendar()}>Save</Button>
                    <Button onClick={() => this.props.onClose && this.props.onClose()}>Close</Button>
                  </div>}
                  header="Cancellation">
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="reason">Select Reason</Label>
              <Input type="select" id="reason" placeholder=""
                     value={getFormFieldValue(this.state.reason)}
                     onChange={(evt) => this.setState({reason: evt.target.value})}>
                >
                {calendarCancelOptions.map((val, i) => {
                  return <option key={i + 1} value={val.id}>{val.display}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="comment">Comment</Label>
              <Input type="text" id="comment" placeholder=""
                     value={getFormFieldValue(this.state.comment)}
                     onChange={(evt) => this.setState({comment: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/modals/CancelCalendarDialog.js